import React from "react";
import T from "prop-types";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { translateProps, toggleSwitch } from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";

export function SendExchangeAgreement({
  contact,
  cc,
  send,
  sending,
  open,
  close,
  company
}) {
  const primaryEmail = `<${contact.email}>`;
  const email = cc ? `${primaryEmail} (cc: <${cc}>)` : primaryEmail;
  const blanketText = `${company.name} has a Blanket Exchange Agreement signed on file and ONLY needs one sent if Special Instructions are required. The Exchange Agreement will be sent to ${email}`;
  const defaultText = `The Exchange Agreement will be sent to ${contact.name} ${email}`;

  return (
    <DropDownItem onClick={open}>
      <i className="fa fa-fw fa-envelope-o" />
      &nbsp;Send Exchange Agreement
      <ConfirmAction
        onConfirm={send}
        close={close}
        open={sending}
        btnText="Yes, Send Exchange Agreement"
        icon={<Icon name="envelope" fixed />}
      >
        <strong>Heads up!</strong>
        &nbsp;{company.blanket_exchange_agreement ? blanketText : defaultText}
      </ConfirmAction>
    </DropDownItem>
  );
}

SendExchangeAgreement.propTypes = {
  contact: T.shape({
    name: T.string.isRequired,
    email: T.string.isRequired
  }).isRequired,
  cc: T.string,
  send: T.func.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired,
  sending: T.bool.isRequired,
  company: T.shape({
    name: T.string.isRequired,
    blanket_exchange_agreement: T.bool.isRequired
  }).isRequired
};

const withProps = translateProps(({ lineItem, salesOrder, close }) => ({
  send: () =>
    api.salesOrders.lineItems
      .sendExchangeAgreement(lineItem.id)
      .then(() => {
        close();
        toastr.success("Success", "Exchange agreement successfully sent.");
      })
      .catch(() =>
        toastr.error(
          "Error",
          "Could not send exchange agreement. Please refresh page and try again."
        )
      ),
  contact: salesOrder.get("contact").toJS(),
  cc: salesOrder.get("cc_email_address")
}));

export default toggleSwitch("sending")(
  withSalesOrder(withProps(SendExchangeAgreement))
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/SendExchangeAgreement.jsx